import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService, ToastConfig } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit, OnDestroy {
  private readonly toastService = inject(ToastService);
  private subscription!: Subscription;
  private dismissTimer: ReturnType<typeof setTimeout> | null = null;

  visible = signal(false);
  dismissing = signal(false);
  text = signal('');
  isDismissable = signal(false);
  type = signal<'default' | 'error'>('default');
  offsetY = signal('24px');
  centerX = signal('50%');

  ngOnInit(): void {
    this.subscription = this.toastService.toast$.subscribe((config) =>
      this.showToast(config),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.clearTimer();
  }

  dismiss(): void {
    this.dismissing.set(true);
    this.clearTimer();
    this.dismissTimer = setTimeout(() => {
      this.visible.set(false);
      this.dismissing.set(false);
    }, 500);
  }

  private showToast(config: ToastConfig): void {
    this.clearTimer();
    this.dismissing.set(false);
    this.text.set(config.text);
    this.isDismissable.set(config.isDismissable);
    this.type.set(config.type ?? 'default');
    this.offsetY.set(config.offsetY ?? '24px');
    this.centerX.set(config.centerX ?? '50%');
    this.visible.set(true);

    if (config.duration > 0) {
      this.dismissTimer = setTimeout(() => this.dismiss(), config.duration);
    }
  }

  private clearTimer(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }
  }
}
